var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-reviews" },
    [
      _vm.REVIEWS.length
        ? [
            _c(
              "div",
              { staticClass: "product-reviews__sort-wrap" },
              [
                _c("ui-select", {
                  staticClass: "product-reviews__sort",
                  attrs: { value: _vm.sortValue, options: _vm.sortOptions },
                  on: { change: _vm.sortChange }
                })
              ],
              1
            ),
            _vm._l(_vm.REVIEWS, function(review) {
              return _c("product-user-review", {
                key: review.id,
                staticClass: "product-reviews__review",
                attrs: {
                  id: review.id,
                  name: review.author.name,
                  date: _vm.createdDate(review.created_at),
                  city: review.author.location,
                  rating: review.rating,
                  "use-time": _vm.getUseTime(review),
                  size: review.dimension,
                  pros: review.pros,
                  cons: review.cons,
                  text: review.body,
                  likes: review.likes,
                  dislikes: review.dislikes,
                  recommended: review.recommended,
                  comments: review.comments
                }
              })
            }),
            _vm.HAS_MORE
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "reached",
                        rawName: "v-reached",
                        value: _vm.loadMore,
                        expression: "loadMore"
                      }
                    ],
                    staticClass: "product-reviews__loader"
                  },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [
                        _vm.isReviewsLoading
                          ? _c("ui-loader", { attrs: { size: "60" } })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : [
            _vm._v(
              "\n    Никто не оставил отзывов по этому товару.\n    Станьте первым\n  "
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }